import React from 'react';
import styles from './ValueSelectorNarrow.module.css';
import { Pencil } from 'lucide-react';

const ValueSelectorNarrow = ({ allowedValues, onValueSelect, onNoteSelect, selectedCell, loading, currentNotes = [], showNotes = false, onToggleNotes }) => {
  // Render a spacer div to maintain consistent layout when no allowed values
  if (!allowedValues || allowedValues.length === 0) {
    return <div className={styles.valueSelector} />;
  }

  return (
    <div className={styles.valueSelector}>
      <div className={styles.selectorRow}>
        {/* Value/Note buttons */}
        {allowedValues.map(value => {
          const isActive = showNotes && currentNotes.includes(value.toString());
          return (
            <button 
              key={`${showNotes ? 'note' : 'value'}-${value}`}
              onClick={() => showNotes ? onNoteSelect && onNoteSelect(value) : onValueSelect(value)}
              disabled={loading || !selectedCell}
              className={`${styles.valueButton} ${isActive ? styles.activeNote : ''} ${showNotes ? styles.noteMode : ''}`}
            >
              {value}
            </button>
          );
        })}
        
        {/* Pencil toggle button */}
        <button 
                onClick={() => onToggleNotes && onToggleNotes(!showNotes)}
                className={`iconButton ${showNotes ? 'primaryButton' : 'secondaryButton'}`}
                disabled={loading}
                title={showNotes ? "Switch to Values" : "Switch to Notes"}
              >
                <Pencil className="buttonIcon" size={16} />
              </button>
      </div>
    </div>
  );
};

export default ValueSelectorNarrow;